// removed by extract-text-webpack-plugin
module.exports = {"pageHeader":"pageHeader___Yz_62","detail":"detail___3fnX6","row":"row___X4z1G","breadcrumb":"breadcrumb___3flYa","tabs":"tabs___SJurw","logo":"logo___2vpOL","title":"title___cazny","action":"action___1DmrO","content":"content___1QHSF","extraContent":"extraContent___21iFk","main":"main___3MXQG"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/PageHeader/index.less
// module id = 438
// module chunks = 0 1